function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { default as MUITypography } from '@mui/material/Typography';
import { useTheme, lighten } from '../styles';
const Typography = /*#__PURE__*/React.forwardRef((props, ref) => {
  const theme = useTheme();
  const getMaxHeight = (maxLines, currentStyle, currentVariant) => {
    const typograpy = theme.typography;
    const vCss = typograpy[currentVariant];
    const myVariantHeight = vCss ? typeof vCss.lineHeight === "number" ? vCss.lineHeight : 1.2 : 1.5;
    const newheight = myVariantHeight * maxLines;
    return {
      display: "inline-block",
      overflow: "hidden",
      height: "".concat(newheight, "em"),
      ...currentStyle
    };
  };
  const setDisabledTextColor = currentStyle => {
    return {
      color: lighten(theme.palette.secondary.main, 0.46),
      ...currentStyle
    };
  };
  const {
    maxLines = null,
    disabled = null,
    style = {},
    ...restProps
  } = props;
  let newStyle = style;
  if (maxLines != null) {
    const {
      variant
    } = restProps;
    newStyle = getMaxHeight(maxLines, style, variant);
  }
  if (disabled) {
    newStyle = setDisabledTextColor(newStyle);
  }
  return /*#__PURE__*/React.createElement(MUITypography, _extends({}, restProps, {
    style: newStyle,
    ref: ref
  }));
});
export default Typography;